module.exports = __webpack_public_path__ + "static/media/PushtimargImage23.0de2a9da.jpg";